import { useCrmStore } from "features/Crm/store/useCrmStore";

export const useAddCustomColumnModal = () => {
  const setIsAddCustomColumnModalOpen = useCrmStore(
    (state) => state.setIsAddCustomColumnModalOpen
  );
  const isAddCustomColumnModalOpen = useCrmStore(
    (state) => state.isAddCustomColumnModalOpen
  );

  const openAddCustomColumnModal = () => {
    setIsAddCustomColumnModalOpen(true);
  };
  const closeAddCustomColumnModal = () => {
    setIsAddCustomColumnModalOpen(false);
  };

  return {
    isAddCustomColumnModalOpen,
    openAddCustomColumnModal,
    closeAddCustomColumnModal,
  };
};
